import '../styles/v3-chrome.css';
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar() {
    const [activeSection, setActiveSection] = useState('hero');
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        if (location.pathname !== '/') {
            setActiveSection('');
            return;
        }

        const handleScroll = () => {
            const sections = ['hero', 'portfolio', 'work-experience', 'about', 'contact'];
            const reversedSections = [...sections].reverse();
            const scrollPosition = window.scrollY + window.innerHeight / 2;

            for (let section of reversedSections) {
                const element = document.getElementById(section);
                if (element) {
                    const rect = element.getBoundingClientRect();
                    const topPos = rect.top + window.scrollY;
                    if (scrollPosition >= topPos) {
                        setActiveSection(section);
                        break;
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, [location.pathname]);

    useEffect(() => {
        setMobileMenuOpen(false);
    }, [location]);

    const handleNavClick = () => {
        setMobileMenuOpen(false);
    };

    const handleBrandClick = () => {
        setMobileMenuOpen(false);

        if (location.pathname === '/') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setActiveSection('hero');
            return;
        }

        window.setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 0);
    };

    const isHomeActive = location.pathname === '/' && activeSection === 'hero';
    const isPortfolioActive = location.pathname === '/' && activeSection === 'portfolio';
    const isExperienceActive = location.pathname === '/' && activeSection === 'work-experience';
    const isAboutActive = location.pathname === '/' && activeSection === 'about';
    const isContactActive = location.pathname === '/' && activeSection === 'contact';

    return (
        <>
            <nav
                className={`v3-navbar ${mobileMenuOpen ? 'v3-navbar--menu-open' : ''}`}
                data-aos="fade-down"
                data-aos-duration="400"
            >
                <Link to="/" className="v3-navbar__mark" onClick={handleBrandClick}>
                    [ VIJAY PAGES ]
                </Link>

                <ul className="v3-navbar__links">
                    <li>
                        <Link
                            to="/"
                            className={`v3-navbar__link ${isHomeActive ? 'v3-navbar__link--active' : ''}`}
                        >
                            Home
                        </Link>
                    </li>
                    <li>
                        <a
                            href={location.pathname === '/' ? '#portfolio' : '/#portfolio'}
                            className={`v3-navbar__link ${isPortfolioActive ? 'v3-navbar__link--active' : ''}`}
                            onClick={handleNavClick}
                        >
                            Projects
                        </a>
                    </li>
                    <li>
                        <a
                            href={location.pathname === '/' ? '#work-experience' : '/#work-experience'}
                            className={`v3-navbar__link ${isExperienceActive ? 'v3-navbar__link--active' : ''}`}
                            onClick={handleNavClick}
                        >
                            Experience
                        </a>
                    </li>
                    <li>
                        <a
                            href={location.pathname === '/' ? '#about' : '/#about'}
                            className={`v3-navbar__link ${isAboutActive ? 'v3-navbar__link--active' : ''}`}
                            onClick={handleNavClick}
                        >
                            About
                        </a>
                    </li>
                    <li>
                        <a
                            href={location.pathname === '/' ? '#contact' : '/#contact'}
                            className={`v3-navbar__link ${isContactActive ? 'v3-navbar__link--active' : ''}`}
                            onClick={handleNavClick}
                        >
                            Contact
                        </a>
                    </li>
                    <li>
                        <a
                            href="/resume.pdf"
                            download="Vijay_Kagupati_Resume.pdf"
                            className="v3-navbar__link"
                            onClick={handleNavClick}
                        >
                            Resume
                        </a>
                    </li>
                </ul>

                <button
                    className="v3-navbar__menu-btn"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    aria-label="Toggle navigation menu"
                    aria-expanded={mobileMenuOpen}
                    aria-controls="v3-mobile-nav"
                    type="button"
                >
                    <span className="v3-navbar__menu-line" aria-hidden="true"></span>
                    <span className="v3-navbar__menu-line" aria-hidden="true"></span>
                    <span className="v3-navbar__menu-line" aria-hidden="true"></span>
                </button>
            </nav>

            {mobileMenuOpen && (
                <div className="v3-navbar__mobile-panel" id="v3-mobile-nav">
                    <Link
                        to="/"
                        className={`${isHomeActive ? 'v3-navbar__link--active' : ''}`}
                        onClick={handleNavClick}
                    >
                        Home
                    </Link>
                    <a
                        href={location.pathname === '/' ? '#portfolio' : '/#portfolio'}
                        className={isPortfolioActive ? 'v3-navbar__link--active' : ''}
                        onClick={handleNavClick}
                    >
                        Projects
                    </a>
                    <a
                        href={location.pathname === '/' ? '#work-experience' : '/#work-experience'}
                        className={isExperienceActive ? 'v3-navbar__link--active' : ''}
                        onClick={handleNavClick}
                    >
                        Experience
                    </a>
                    <a
                        href={location.pathname === '/' ? '#about' : '/#about'}
                        className={isAboutActive ? 'v3-navbar__link--active' : ''}
                        onClick={handleNavClick}
                    >
                        About
                    </a>
                    <a
                        href={location.pathname === '/' ? '#contact' : '/#contact'}
                        className={isContactActive ? 'v3-navbar__link--active' : ''}
                        onClick={handleNavClick}
                    >
                        Contact
                    </a>
                    <a
                        href="/resume.pdf"
                        download="Vijay_Kagupati_Resume.pdf"
                        onClick={handleNavClick}
                    >
                        Resume
                    </a>
                </div>
            )}
        </>
    );
}

export default Navbar;
